<template>
  <div class="works__list__container">
    <work-card class="works__list__img__area"
          v-for="workKey in projectData"
          :mobFocusHeightMiddle = mobFocusHeightMiddle
          :key="workKey.id"
          :titleUrl="workKey.title_key"
          :tagKey="workKey.title_key"
          :title="workKey.title"
          :titleEn="workKey.title_en"
          :projectYear="workKey.year"
          :tag="workKey.tags[1]"
          :imgSrc="getImgUrl(workKey.title_key)"
          :isDisplay="workKey.tags.indexOf($route.params.url) !== -1"
          />
  </div>
</template>
<script>
import projectData from "../../../public/project_data.json"
import WorkCard from './WorkCard'
export default {
  name: "WorksList",
  // 親から受け取るデータ
  props: {
    tag: String
  },
  data() {
    return {
      projectData,
      // モバイルのピント領域
      mobFocusHeightMiddle: 200,
    };
  },
  created() {
    if (navigator.userAgent.indexOf('iPhone') > 0 ||
      navigator.userAgent.indexOf('iPad') > 0 ||
      navigator.userAgent.indexOf('Android') > 0) {
        // ブラウザ表示領域の高さ取得
        var innerHeight = window.innerHeight;
        // ブラウザの高さの中央位置を格納
        this.mobFocusHeightMiddle = innerHeight * 0.4;
    }
  },
  components: {
    'work-card': WorkCard
  },
  methods: {
    getImgUrl(workKey) {
      var imgUrl = "/assets/img/works/"+ workKey + ".jpg"
      return imgUrl
    }
  }
};
</script>
<style lang="scss" scoped>
.works__list__container {
  position: relative;
  margin-bottom: 100px;
  padding-top: 16vh;
}
@media screen and (min-width: 768px) {
  .works__list__container {
    padding-top: 16vh;
    margin-bottom: auto;
  }
}
@media screen and (min-width: 1287px) {
  .works__list__container {
    padding-top: 3.5vw;
  }
}
@media screen and (min-width: 1572px) {
  .works__list__container {
    padding-top: 55px;
  }
}
</style>